/* ==========================================================================
   NORDIC ENHANCEMENTS JS
   Card quantity selector (+/- buttons on product cards) with persistence
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     QUANTITY STORAGE — persist card quantities across page loads & re-renders
     Uses sessionStorage keyed by variant ID so qty survives add-to-cart
     -------------------------------------------------------------------------- */
  var QTY_STORAGE_KEY = 'nd_card_qtys';

  function getSavedQtys() {
    try {
      return JSON.parse(sessionStorage.getItem(QTY_STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveQty(variantId, qty) {
    var data = getSavedQtys();
    data[variantId] = qty;
    try { sessionStorage.setItem(QTY_STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function getVariantIdFromForm(form) {
    var input = form.querySelector('.product-variant-id, [name="id"]');
    return input ? input.value : null;
  }

  /* --------------------------------------------------------------------------
     CARD QUANTITY SELECTOR — +/- buttons with persistence
     -------------------------------------------------------------------------- */
  function initCardQtySelectors() {
    // Restore saved quantities on page load
    restoreCardQuantities();

    // Event delegation for +/- buttons (survives re-renders)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.card-qty-btn');
      if (!btn) return;

      var selector = btn.closest('.card-qty-selector');
      if (!selector) return;

      var input = selector.querySelector('.card-qty-input');
      if (!input) return;

      var currentVal = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      var step = parseInt(input.step, 10) || 1;

      if (btn.classList.contains('card-qty-btn--minus')) {
        if (currentVal - step >= min) input.value = currentVal - step;
      } else if (btn.classList.contains('card-qty-btn--plus')) {
        if (currentVal + step <= max) input.value = currentVal + step;
      }

      // Persist the new value
      var form = selector.closest('form');
      if (form) {
        var vid = getVariantIdFromForm(form);
        if (vid) saveQty(vid, input.value);
      }
    });

    // Also persist on manual input change
    document.addEventListener('change', function (e) {
      if (!e.target.classList.contains('card-qty-input')) return;
      var form = e.target.closest('form');
      if (form) {
        var vid = getVariantIdFromForm(form);
        if (vid) saveQty(vid, e.target.value);
      }
    });

    // Watch for Shopify section re-renders (DOM mutations) and restore qtys
    var gridObserver = new MutationObserver(function (mutations) {
      var shouldRestore = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          shouldRestore = true;
          break;
        }
      }
      if (shouldRestore) restoreCardQuantities();
    });

    // Observe the main content area for section re-renders
    var main = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    gridObserver.observe(main, { childList: true, subtree: true });
  }

  function restoreCardQuantities() {
    var saved = getSavedQtys();
    var keys = Object.keys(saved);
    if (keys.length === 0) return;

    document.querySelectorAll('.card-qty-input').forEach(function (input) {
      var form = input.closest('form');
      if (!form) return;
      var vid = getVariantIdFromForm(form);
      if (vid && saved[vid]) {
        input.value = saved[vid];
      }
    });
  }

  /* --------------------------------------------------------------------------
     INIT
     -------------------------------------------------------------------------- */
  function init() {
    initCardQtySelectors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
